// LotWise Auto — named dealership case studies.
//
// This file backs the Home page CaseStudy section. When a case study
// is APPROVED (dealership signed off on name, quote, logo, and
// photography), set `approved: true` and populate the fields below.
// Until then, the entry ships as a labelled draft so the layout and
// story shape are visible to the LotWise team without misrepresenting
// a real partner.
//
// Fields:
//   - id: url-safe slug
//   - approved: boolean — controls whether the case study is shown
//     publicly. False → replaced by a "Draft — pending approval"
//     placeholder card so LotWise can preview the layout privately
//     (only visible when ?preview=case-studies is on the URL).
//   - dealership: legal or trading name of the dealership
//   - city: location city (matches a REGIONS slug where possible)
//   - logo_url: optional path to dealership logo. Falls back to a
//     styled text mark when omitted.
//   - hero_photo: path to a real lot photo of the dealership
//   - quote: the pull quote (short, punchy, dealership-voice)
//   - principal_name: full name of the quoted principal
//   - principal_role: role at the dealership
//   - metrics: 2 to 3 short KPIs (label + value) as social proof
//   - service_model_id: 'scheduled_lot' | 'managed_inventory'
//   - service_model_label: display label
//   - result_paragraph: one short paragraph of business outcome

export const CASE_STUDIES = [
  {
    id: "ottawa-flagship",
    approved: false,
    dealership: "Ottawa flagship dealership",
    city: "ottawa",
    logo_url: null,
    hero_photo: "/generated/black-suv-after.png",
    quote:
      "We stopped asking our sales team to handle photos. The listings finally look like the lot actually looks.",
    principal_name: "Pending approval",
    principal_role: "Used Vehicle Manager",
    service_model_id: "scheduled_lot",
    service_model_label: "Scheduled Lot Service",
    metrics: [
      { label: "Listing standard", value: "Held every visit" },
      { label: "Cadence", value: "Weekly onsite" },
      { label: "Priority platforms", value: "AutoTrader · CarGurus · FB · Kijiji" },
    ],
    result_paragraph:
      "Sales-floor time is back on selling. The online lot now matches the standard the sales team delivers in person, with no internal handoffs and no listing drift between visits.",
  },
];

// Public case studies (approved only). Home renders these directly.
export const APPROVED_CASE_STUDIES = CASE_STUDIES.filter((c) => c.approved);
